<template>
    <div class="tournaments_container">
        <div class="tabs-selector">
            <div class="tabs-selector-wrapper">
                <div class="tab active">Turnee online</div>
                <div class="tab" @click="enter_offline">Turnee offline</div>
            </div>
        </div>
        <div class="tournaments-container">
            <ZDJPage v-bind:target-uri="$route.path.substring('/gamezone'.length)" class="zdj-component-container"/>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .tournaments_container{
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .tournaments-container{
        width: 100%;
        display: inline-block;
        position: relative;
        min-height: 100vh;
    }
</style>
<script>
    import ZDJPage from "@/components/ZDJPage/ZDJPage";
    import i18n from '@/i18n';

    export default {
        name: 'zdjTabs',
        components: {ZDJPage},
        data() {
            return {
                targetUri: ''
            }
        },
        created() {
        },
        methods: {
            enter_offline(){
                this.$router.push({
                    name:"offline_tournament",
                    params:{
                        locale:i18n.locale,
                    }
                });
            }
        }
    }
</script>